import styled from 'styled-components';
import { VizTheme } from './theme';

export const StyledHeatMap = styled.div<{
    gap: number;
    theme: VizTheme;
}>`
    ${({ gap, theme }): string => `
        gap: ${gap}px;
        --tooltip-line-stroke: ${theme.tooltip.lineStroke};
    `}
    align-items: center;
    display: flex;

    /* Overwrite uplot style */
    .uplot {
        position: relative;
    }

    .u-select {
        background: rgba(0, 0, 0, 0.3);
    }

    .u-hz .u-cursor-x {
        border-right: 1px solid var(--tooltip-line-stroke);
    }
`;
